<div *ngIf="state === PROCESSING">
  <r247-processing-loader caption="Confirming Payment" subCaption="Please wait while we confirm your registration payment"></r247-processing-loader>
</div>

<div *ngIf="state === SUCCESS">
  <div class="card">
    <div class="card-header">Registration Successful</div>
    <div class="card-body">
      <h1>You have successfully registered your account.</h1>
    </div>
    <div class="card-footer">
      <a class="btn btn-primary float-right" [routerLink]="['/auth/login']">Log in</a>
    </div>
  </div>
</div>

<div *ngIf="state === FAIL">
  <div class="card">
    <div class="card-header">Registration Failed</div>
    <div class="card-body">
      <p>{{errorMessage}}</p>
    </div>
    <div class="card-footer">
      <a class="btn btn-primary float-right" [routerLink]="['/register/account']">Try Again</a>
    </div>
  </div>
</div>
